import { Link } from 'react-router-dom';

/** Tiles da Home, com as mesmas cores e descrições do protótipo. */
const TILES = [
  { rota: '/roadmap', icone: '▤', nome: 'Quadro de Tarefas', desc: 'Cronograma do projeto em timeline e kanban.', cor: '#C9A25A' },
  { rota: '/equipe', icone: '☺', nome: 'Equipe', desc: 'Os seis fundadores e suas frentes.', cor: '#4E9C6B' },
  { rota: '/marketing', icone: '✦', nome: 'Marketing e Branding', desc: 'Marca, growth e conteúdo do jogo.', cor: '#B04A45' },
  { rota: '/campanhas', icone: '◈', nome: 'Campanhas', desc: 'Planejador de campanhas, do Beta à Season 1.', cor: '#A87BD0' },
];

export function Home() {
  return (
    <div className="hero">
      <h1>Bem-vindo à Game Engine da Goyaz Games</h1>
      <div className="lead">
        Um só lugar para pilotar o <b>Mistik Island</b>: planejar o projeto, coordenar a equipe e
        construir o mundo do jogo. Escolha um módulo abaixo ou pelo menu à esquerda.
      </div>
      <div className="tiles">
        {TILES.map((tile) => (
          <Link key={tile.rota} to={tile.rota} className="tile" style={{ '--c': tile.cor } as React.CSSProperties}>
            <div className="ti">{tile.icone}</div>
            <div className="tn">{tile.nome}</div>
            <div className="td">{tile.desc}</div>
          </Link>
        ))}
      </div>
    </div>
  );
}
